module.exports = __webpack_public_path__ + "static/media/bac-off-app-provider-icon.68603161.svg";